import { Scale } from "@pdfking/math"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Roddenberry, a long desk calendar: the year low on its picture; a month under its picture, its name over its days across in a strip, the logo beside it. */
export const Roddenberry: CalendarDesign = {
  cover: PictureCover({ at: 0.3 }),
  page: ({ gap, labels, language, outer, page, short, year }, month) => {
    const picture = Region(page, 0, 0.3, 1, 1)
    const below = Slice.under(outer, picture.y, gap)
    return [
      Area.picture(picture, month),
      Area.title(Slice.top(Region(below, 0, 0, 0.85, 1), Scale(short, 0.07))[0], month, language),
      Area.strip(Region(below, 0, 0, 0.85, 0.55), month, year),
      Area.logo(Region(below, 0.88, 0, 1, 1), labels),
    ]
  },
  pages: "month",
}
